import React from 'react';
import PropTypes from 'prop-types';

import Styles from './Slider.styles';

export const SliderTrack = ({
  className,
  getTrackProps,
  source,
  target,
}) => (
  <div
    className={`${Styles.track} ${className}`}
    style={{
      left: `${source.percent}%`,
      width: `${target.percent - source.percent}%`,
    }}
    {...getTrackProps()}
  />
);

SliderTrack.propTypes = {
  className: PropTypes.string,
  getTrackProps: PropTypes.func.isRequired,
  source: PropTypes.shape({
    percent: PropTypes.number.isRequired,
  }).isRequired,
  target: PropTypes.shape({
    percent: PropTypes.number.isRequired,
  }).isRequired,
};

SliderTrack.defaultProps = {
  className: '',
};

export default SliderTrack;
